import type { paths } from "@securityjourney/svc-idp/dist/gen/idp.d.ts";
import {
  ServiceClient,
  TokenFunc,
  Call,
  ServiceResponse,
  ServiceError,
} from "@securityjourney/service-client";

import * as IdpTypes from "./idpTypes";

export class IdpClient extends ServiceClient<paths> {
  constructor(getToken: TokenFunc, url?: string) {
    super({ getToken, url });
  }

  async confirmEmail(
    req: IdpTypes.ManuallyConfirmEmailRequest
  ): Promise<ServiceResponse<IdpTypes.ManuallyConfirmEmailResponse>> {
    return await this.post("/svc/idp/confirm-email", req);
  }

  refreshToken(): Call<void> {
    const func = this.fetcher.path("/svc/idp/auth/refresh").method("post").create();
    const { init, abort } = this.withAbort();
    return {
      abort,
      promise: func({}, { ...init, credentials: "include" })
        .then(() => undefined)
        .catch(ServiceError.raise),
    };
  }

  signOut(): Call<void> {
    const func = this.fetcher.path("/svc/idp/auth/signout").method("post").create();
    const { init, abort } = this.withAbort();
    return {
      abort,
      promise: func({}, { ...init, credentials: "include" })
        .then(() => undefined)
        .catch(ServiceError.raise),
    };
  }
}
